let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7LVlm")).then(() => parcelRequire('5FLbD'));